import { RefreshCw } from "lucide-react";

export function PatternStatus({ loading, data, list }) {
  if (loading) {
    return (
      <div className="text-sm text-stone-500 inline-flex items-center gap-2" data-testid="pattern-loading">
        <RefreshCw className="w-3.5 h-3.5 animate-spin" /> Looking across your check-ins…
      </div>
    );
  }
  if (data && !data.enough_data) {
    return (
      <p className="text-sm text-stone-500" data-testid="pattern-not-enough">
        {data.days_logged} day{data.days_logged === 1 ? "" : "s"} logged so far. After about 8 days of wellbeing check-ins alongside habit check-ins, links start to show up here.
      </p>
    );
  }
  if (data && data.enough_data && list.length === 0) {
    return <p className="text-sm text-stone-500" data-testid="pattern-none">No clear links yet — keep logging and this will sharpen over time.</p>;
  }
  return null;
}

export function PatternFinding({ f, index }) {
  return (
    <li className="text-xs text-stone-700 flex items-start gap-2" data-testid={`pattern-finding-${index}`}>
      <span className={`mt-1 w-2 h-2 rounded-full shrink-0 ${f.positive ? "bg-emerald-500" : "bg-amber-400"}`} />
      <span>
        {f.kind === "habit" ? "Days with" : "Days logging"} <span className="font-semibold">{f.name}</span>: {f.scale_label.toLowerCase()}{" "}
        <span className="font-mono text-amber-800">{f.with_avg}</span> vs <span className="font-mono text-stone-500">{f.without_avg}</span> on other days
        <span className="text-stone-400"> ({f.n_with}/{f.n_without} days)</span>
      </span>
    </li>
  );
}

export function PatternFindingList({ list, className = "" }) {
  if (list.length === 0) return null;
  return (
    <ul className={`space-y-1.5 ${className}`} data-testid="pattern-findings">
      {list.map((f, i) => <PatternFinding key={`${f.kind}-${f.name}-${f.scale_label}`} f={f} index={i} />)}
    </ul>
  );
}
